// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"Paginated_pageBtn__14JZv","pagination":"Paginated_pagination__1c2lQ"};